import { apiClient } from 'src/shared/utils/apiClient';

export async function dismissNotification(id: number, token: AccessToken): Promise<void> {
  return apiClient(`/v1/notifications/dismiss/${id}`, { token, method: 'POST' });
}
